<template>
    <section
        class="section"
        :class="{ 'section--centered': centered }"
        :data-width="sectionWidth"
    >
        <div class="section__container">
            <div
                v-if="!!$slots.title"
                class="section__header"
            >
                <h2 class="section__title">
                    <slot name="title" />
                </h2>
                <div v-if="!!$slots.description" class="section__description">
                    <slot name="description" />
                </div>
            </div>

            <div class="section__body">
                <slot />
            </div>
        </div>
    </section>
</template>

<script>
export default {
    props: {
        sectionWidth: {
            type: String,
            default: 'page',
            validator(value) {
                return ['page', 'content', 'content-sm', 'content-md', 'content-lg', 'bleed'].includes(value);
            }
        },
        centered: {
            type: Boolean,
            default: false
        }
    }
};
</script>

<style lang="less" src="./BaseSection.less" />
